// import logo from './logo.svg';
import './App.css';
import Header from './Components/Header/Header';
import Friends from './Components/Friends/Friends';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Friends></Friends>
    </div>
  );
}

export default App;
